export const textToBlob = (text) => {
  return new Blob([text], { type: 'text/plain' })
}
export const blobToText = async (blob) => {
  return await blob.text()
}